import { Observable } from "rxjs";
import {
  Cellar,
  Inventory,
  BlackBoxInput,
  BlackBoxDetailInput,
  InventoryUpdateDto,
} from "src/app/interface/admin";
import { ProductFeature } from "src/app/interface/bill";
import { Tag, ProductDiscount } from "src/app/interface/product";

export class GetCellars {
  static readonly type = "[Admin] GetCellars]";
}
export class RemoveProductsAndFeature {
  static readonly type = "[Admin] Mutation RemoveProductsAndFeature]";
  constructor(public readonly id: any) {}
}

export class GetRolesByPlace {
  static readonly type = "[Admin] GetRolesByPlace]";
}

export class CleanAdminPage {
  static readonly type = "[CleanAdminPage]";
}

export class CreateCellar {
  static readonly type = "[Admin] CreateCellar]";
  constructor(public readonly newCellar: Cellar) {}
}

export class CreateInventory {
  static readonly type = "[Admin] CreateInventory]";
  constructor(public readonly newInventory: InventoryUpdateDto) {}
}

export class CreateBlackBox {
  static readonly type = "[Admin] CreateBlackBox]";
  constructor(public readonly blackBoxInput: BlackBoxInput) {}
}

export class UpdateBlackBox {
  static readonly type = "[Admin] UpdateBlackBox]";
  constructor(public readonly blackBoxInput: BlackBoxInput) {}
}

export class SendNotification {
  static readonly type = "[Admin] SendNotification]";
  constructor(public readonly notification: Notification) {}
}

export class HideBlackBox {
  static readonly type = "[Admin] HideBlackBox]";
  constructor(public readonly id: string) {}
}

export class RestoreBlackBox {
  static readonly type = "[Admin] RestoreBlackBox]";
  constructor(public readonly id: string) {}
}

export class CreateBlackBoxDetail {
  static readonly type = "[Admin] CreateBlackBoxDetail]";
  constructor(public readonly blackBoxDetailInput: BlackBoxDetailInput) {}
}

export class UpdateBlackBoxDetail {
  static readonly type = "[Admin] UpdateBlackBoxDetail]";
  constructor(public readonly blackBoxDetailInput: BlackBoxDetailInput) {}
}

export class TransactionBlackBoxDetail {
  static readonly type = "[Admin] TransactionBlackBoxDetail]";
  constructor(
    public readonly from: string,
    public readonly to: string,
    public readonly value: string
  ) {}
}

export class AddFeatureToBill {
  static readonly type = "[Admin] AddFeatureToBill]";
  constructor(public readonly feature: ProductFeature = null) {}
}

export class GetInventories {
  static readonly type = "[Admin] GetInventories]";
  constructor(public readonly id: string) {}
}

export class FindFeatures {
  static readonly type = "[Admin] FindFeatures]";
  constructor(public readonly criteria: string) {}
}

export class HandleCellarState {
  static readonly type = "[Admin] HandleCellarState]";
  constructor(public readonly id: string, public readonly state: any) {}
}

export class ViewCellarsDesactive {
  static readonly type = "[Admin] ViewCellarsDesactive]";
  constructor(public readonly viewDesactive: any) {}
}

export class RemoveInventory {
  static readonly type = "[Admin] RemoveInventory]";
  constructor(public readonly id: string) {}
}

export class GetMeasures {
  static readonly type = "[Admin] GetMeasures]";
}

export class GetAllCoins {
  static readonly type = "[Admin] GetAllCoins]";
}

export class GetBlackBoxesByPlace {
  static readonly type = "[Admin] GetBlackBoxesByPlace]";
}

export class GetTransferBlackBoxesByPlace {
  static readonly type = "[Admin] GetTransferBlackBoxesByPlace]";
}

export class SearchTransferBlackBoxes {
  static readonly type = "[Admin] SearchTransferBlackBoxes]";
  constructor(public readonly criteria: string) {}
}

export class SearchBlackBoxes {
  static readonly type = "[Admin] SearchBlackBoxes]";
  constructor(public readonly criteria: string) {}
}

export class CreateInventoryDetail {
  static readonly type = "[Admin] CreateInventoryDetail]";
  constructor(
    public readonly newInventoryDetail: any,
    public readonly fetchDetails?: Function
  ) {}
}

export class HideInventoryDetail {
  static readonly type = "[Admin] HideInventoryDetail]";
  constructor(public readonly id: string) {}
}

export class GetInventoryDetail {
  static readonly type = "[Admin] GetInventoryDetail]";
  constructor(public readonly id: string) {}
}

export class GetProductStates {
  static readonly type = "[Admin] GetProductStates]";
}

export class GetUsersByPlace {
  static readonly type = "[Admin] GetUsersByPlace]";
}

export class FindUsersByPlace {
  static readonly type = "[Admin] FindUsersByPlace]";
  constructor(public readonly criteria: string) {}
}

export class UpdateCellar {
  static readonly type = "[Admin] UpdateCellar]";
  constructor(public readonly cellarUpdate: Cellar) {}
}

export class UpdateInventory {
  static readonly type = "[Admin] UpdateInventory]";
  constructor(public readonly inventoryUpdate: InventoryUpdateDto) {}
}

export class UpdateQuantityPromotion {
  static readonly type = "[Admin] UpdateQuantityPromotion]";
  constructor(public readonly id: string, public readonly quantity: number) {}
}

export class UpdateInventoryState {
  static readonly type = "[Admin] UpdateInventoryState]";
  constructor(public readonly id, public readonly State_Inventory) {}
}

export class UpdateInventoryDetail {
  static readonly type = "[Admin] UpdateInventoryDetail]";
  constructor(public readonly detailUpdate: any) {}
}

export class RestoreInventoryDetail {
  static readonly type = "[Admin] RestoreInventoryDetail]";
  constructor(public readonly detailRestore: number) {}
}

export class ClearInventoryDetail {
  static readonly type = "[Admin] ClearInventoryDetail]";
}

export class GetKeysFeatures {
  static readonly type = "[Admin] GetKeysFeatures]";
}

export class GetFeaturesByDetail {
  static readonly type = "[Admin] GetFeaturesByDetail]";
  constructor(public readonly id: string) {}
}

export class TagsByInventoryDetailPlace {
  static readonly type = "[Admin] TagsByInventoryDetailPlace]";
  constructor(public readonly id: string) {}
}

export class UploadPlaceGalleryPicture {
  static readonly type = "[Admin] UploadPlaceGalleryPicture]";
  constructor(public readonly file) {}
}

export class SaveImageRouteForPlaceGallery {
  static readonly type = "[Admin] SaveImageRouteForPlaceGallery]";
  constructor(
    public readonly fileRef: Observable<any>,
    public readonly FirebaseId: string,
    public readonly PlaceId
  ) {}
}
export class SaveGalleryFile {
  static readonly type = "[User] SaveGalleryFile]";
  constructor(
    public readonly FilePath,
    public readonly FirebaseId,
    public readonly PlaceId
  ) {}
}
export class UploadImage {
  static readonly type = "[Admin] UploadImage]";
  constructor(
    public readonly file: any,
    public readonly FK_ProductFeature: any,
    public readonly FK_InventoryDetail: string,
    public readonly fromCadesur?: boolean
  ) {}
}

export class SaveImageRoute {
  static readonly type = "[Admin] SaveImageRoute]";
  constructor(
    public readonly fileRef: Observable<any>,
    public readonly FK_ProductFeature: any,
    public readonly FK_InventoryDetail: string,
    public readonly FirebaseId: String,
    public readonly fromCadesur?: boolean
  ) {}
}

export class CreateFeatureFile {
  static readonly type = "[Admin] CreateFeatureFile]";
  constructor(
    public readonly Route_File: string,
    public readonly FK_ProductFeature: string,
    public readonly FK_InventoryDetail: string,
    public readonly FirebaseId: String
  ) {}
}

export class OpenDialog {
  static readonly type = "[Admin] OpenDialog]";
  constructor(public readonly component: any, public readonly data: any) {}
}

export class AddProductDetail {
  static readonly type = "[Admin] AddProductDetail]";
  constructor(
    public readonly _featureDetail: any,
    public readonly FK_InventoryDetail: string
  ) {}
}

export class UpdateProductDetail {
  static readonly type = "[Admin] UpdateProductDetail]";
  constructor(
    public readonly _featureDetail: any,
    public readonly FK_InventoryDetail: string
  ) {}
}

export class RemoveProductDetail {
  static readonly type = "[Admin] removeProductDetail]";
  constructor(
    public readonly id: string,
    public readonly FK_InventoryDetail: string,
    public readonly FK_ProductFeature: string
  ) {}
}

export class AddProductFeature {
  static readonly type = "[Admin] AddProductFeature]";
  constructor(public readonly newFeature: any) {}
}

export class UpdateProductPrice {
  static readonly type = "[Admin] UpdateProductPrice]";
  constructor(
    public readonly newPrice: any,
    public readonly detailId: string
  ) {}
}

export class UpdateFeatureQuantity {
  static readonly type = "[Admin] UpdateFeatureQuantity]";
  constructor(
    public readonly newQuantity: any,
    public readonly detailId: string
  ) {}
}

export class UpdateProductFeature {
  static readonly type = "[Admin] UpdateProductFeature]";
  constructor(
    public readonly newPrice: any,
    public readonly newQuantity: any,
    public readonly detailId: string
  ) {}
}
export class GetPriceHistory {
  static readonly type = "[Admin] GetPriceHistory]";
  constructor(public readonly id: string) {}
}

export class RemoveFeatureFile {
  static readonly type = "[Admin] RemoveFeatureFile]";
  constructor(
    public readonly id: string,
    public readonly detailId: string,
    public readonly featureId: string
  ) {}
}

export class AddProductTag {
  static readonly type = "[Admin] AddProductTag]";
  constructor(public readonly productTag: any) {}
}

export class RemoveProductTag {
  static readonly type = "[Admin] RemoveProductTag]";
  constructor(
    public readonly FK_Product: string,
    public readonly FK_Tag: string
  ) {}
}

export class GenerateFeatureQr {
  static readonly type = "[Admin] GenerateFeatureQr]";
  constructor(
    public readonly detail: string,
    public readonly FK_ProductFeature: string
  ) {}
}

export class GenerateFeatureBarCode {
  static readonly type = "[Admin] GenerateFeatureBarCode]";
  constructor(
    public readonly detail: string,
    public readonly FK_ProductFeature: string,
    public readonly FeatureCode: string,
    public readonly id?: string
  ) {}
}

export class GetBillsByPlaceAndState {
  static readonly type = "[Admin] GetBillsByPlaceAndState]";
  constructor(public readonly FK_BillState) {}
}

export class CreateDeliveryForPlaceAdmin {
  static readonly type = "[Admin] CreateDeliveryForPlaceAdmin";
  constructor(public readonly bills, public readonly FK_User?: string) {}
}

export class GetBillDetailByBillAndPlace {
  static readonly type = "[Admin] GetBillDetailByBillAndPlace]";
  constructor(public readonly FK_Bill) {}
}

export class GetDeliveryByUser {
  static readonly type = "[Admin] GetDeliveryByUser]";
}

export class GetBillDetailsForDelivery {
  static readonly type = "[Admin] GetBillDetailsForDelivery]";
}

export class UpdateBillDetailState {
  static readonly type = "[Admin] UpdateBillDetailState]";
  constructor(
    public readonly id,
    public readonly state,
    public readonly quantity?
  ) {}
}

export class CheckBillDetail {
  static readonly type = "[Admin] CheckBillDetail]";
  constructor(public readonly id, public readonly quantity) {}
}

export class UpdateDeliveryToReady {
  static readonly type = "[Admin] Mutation UpdateDeliveryToReady]";
}

export class UpdateBillDetails {
  static readonly type = "[Admin] Mutation UpdateBillDetails]";
}

export class UpdateBillDetailsToDelivered {
  static readonly type = "[Admin] Mutation UpdateBillDetailsToDelivered]";
  constructor(public readonly details) {}
}

export class FindFeaturesByPlace {
  static readonly type = "[Admin] Query FindFeaturesByPlace]";
  constructor(public readonly criteria) {}
}

export class AddElementToNavigation {
  static readonly type = "[Admin] Query AddElementToNavigation]";
  constructor(public readonly type, public readonly value) {}
}

export class GetInventoryDetailForSearch {
  static readonly type = "[Admin] Query GetInventoryDetailForSearch]";
  constructor(public readonly features, public readonly productId) {}
}

export class GetCurrentCarts {
  static readonly type = "[Admin] GetCurrentCarts]";
}

export class ActiveUserByPlace {
  static readonly type = "[Admin]  ActiveUserByPlace]";
}

export class ProductsByCategory {
  static readonly type = "[Admin]  ProductsByCategory]";
}
export class GetAllBlackBoxDetailType {
  static readonly type = "[Admin] Query GetAllBlackBoxDetailType]";
}

export class GetFilesByPlaceAndType {
  static readonly type = "[Admin] Mutation GetFilesByPlaceAndType]";
  constructor(public readonly FK_FileType) {}
}

export class SetBillStatesFilter {
  static readonly type = "[Admin] Mutation SetBillStatesFilter]";
  constructor(public readonly billStatesFilter) {}
}

export class ShoppersByPlace {
  static readonly type = "[Admin] ShoppersByPlace]";
}

export class FindFeaturesByPlaceForBill {
  static readonly type = "[Admin] Query FindFeaturesByPlaceForBill]";
  constructor(public readonly criteria) {}
}

export class ResetTemporalBill {
  static readonly type = "[Admin] Mutation ResetTemporalBill]";
}

export class UpdateQuantityOfTemporalBillDetail {
  static readonly type = "[Admin] Mutation UpdateQuantityOfTemporalBillDetail]";
  constructor(public readonly id, public readonly Quantity) {}
}

export class RemoveTemporaryBillDetail {
  static readonly type = "[Admin] Mutation RemoveTemporaryBillDetail]";
  constructor(public readonly id) {}
}

export class SelectDefaultCashierCoin {
  static readonly type = "[Admin] Mutation SelectDefaultCashierCoin]";
  constructor(public readonly id) {}
}

export class UpdateDefaultCashierCoin {
  static readonly type = "[Admin] Mutation UpdateDefaultCashierCoin]";
}

export class GetUserByCriteriaForTemporaryBill {
  static readonly type = "[Admin] Query GetUserByCriteriaForTemporaryBill]";
  constructor(public readonly criteria: any) {}
}

export class ResetChargedClient {
  static readonly type = "[Admin] Mutation ResetChargedClient]";
}

export class CreateBillForCashier {
  static readonly type = "[Admin] CreateBillForCashier]";
  constructor(
    public readonly OtherInfo,
    public readonly Total_Bill,
    public readonly SubTotal_Bill,
    public readonly FK_TypeOfPay,
    public readonly FK_Account,
    public readonly FK_PromotionalCode
  ) {}
}

export class CheckIfAccountIsEnough {
  static readonly type = "[Admin] Query CheckIfAccountIsEnough]";
  constructor(public readonly FK_Account, public readonly Total) {}
}

export class GetAllTaxes {
  static readonly type = "[Admin] Query GetAllTaxes]";
}

export class AssignNewTaxToProduct {
  static readonly type = "[Admin] Mutation AssignNewTaxToProduct]";
  constructor(public readonly id, public readonly FK_Product) {}
}

export class ResetInsufficientFunds {
  static readonly type = "[Admin] ResetInsufficientFunds]";
}

export class GetInventoriesByPlace {
  static readonly type = "[Admin] GetInventoriesByPlace]";
}

export class CloneInventoryDetail {
  static readonly type = "[Admin] Mutation CloneInventoryDetail]";
  constructor(public readonly detail) {}
}

export class MoveInventoryDetail {
  static readonly type = "[Admin] Mutation MoveInventoryDetail]";
  constructor(public readonly FK_Inventory, public readonly FK_Product) {}
}

export class UpdateRestrictedProduct {
  static readonly type = "[Admin] Mutation UpdateRestrictedProduct]";
  constructor(
    public readonly id: string,
    public readonly Restricted_Product: boolean
  ) {}
}

export class GetBlackBoxByUser {
  static readonly type = "[Admin] Query GetBlackBoxByUser]";
}

export class PayWithAccountFromAdmin {
  static readonly type = "[Admin] Mutation PayWithAccountFromAdmin]";
  constructor(public readonly FK_Account, public readonly Total) {}
}

export class UpdateBlackBoxDetailOfCashier {
  static readonly type = "[Admin] UpdateBlackBoxDetailOfCashier]";
  constructor(
    public readonly blackBoxDetailInput: BlackBoxDetailInput,
    public readonly otherInfo: string,
    public readonly FK_Bill
  ) {}
}

export class AddUserToPayment {
  static readonly type = "[Admin] Mutation AddUserToPayment]";
  constructor(public readonly user) {}
}

export class EditUserToPayment {
  static readonly type = "[Admin] Mutation EditUserToPayment]";
  constructor(public readonly user) {}
}

export class DeleteItemOfUsersBill {
  static readonly type = "[Admin] Mutation DeleteItemOfUsersBill]";
  constructor(public readonly id) {}
}

export class PayBillCashierMultiple {
  static readonly type = "[Admin] Mutation PayBillCashierMultiple]";
  constructor(public readonly Values, public readonly FK_Bill) {}
}

export class CheckWalletsAndPayMultiple {
  static readonly type = "[Admin] Query CheckWalletsAndPayMultiple]";
  constructor(
    public readonly accountGroup,
    public readonly normalGroup,
    public readonly FK_Bill
  ) {}
}

export class FinishMultiplePayment {
  static readonly type = "[Admin] Mutation FinishMultiplePayment]";
  constructor(public readonly finalValues, public readonly FK_Bill) {}
}

export class UpdateFeatureLocation {
  static readonly type = "[Admin] Mutation UpdateFeatureLocation]";
  constructor(
    public readonly id,
    public readonly Location_ProductFeature,
    public readonly FK_InventoryDetail
  ) {}
}

export class GetActiveCellarsByPlace {
  static readonly type = "[Admin] Query GetActiveCellarsByPlace]";
}

export class GetAllTariff {
  static readonly type = "[Admin] Query GetAllTariff]";
}

export class IsPromotionalCodeValid {
  static readonly type = "[Admin] Query IsPromotionalCodeValid]";
  constructor(
    public readonly FK_User,
    public readonly UniqueCode_PromotionalCode
  ) {}
}

export class ResetPromotionalCodeForCashier {
  static readonly type = "[Admin] Mutation ResetPromotionalCodeForCashier]";
}

export class UpdateCadesurCodeProductFeature {
  static readonly type = "[Admin] Mutation UpdateCadesurCodeProductFeature]";
  constructor(
    public readonly id,
    public readonly CadesurCode_ProductFeature,
    public readonly FK_InventoryDetail
  ) {}
}

export class UpdatePreparationTimeOfProductFeature {
  static readonly type =
    "[Admin] Mutation UpdatePreparationTimeOfProductFeature]";
  constructor(
    public readonly id,
    public readonly PreparationTime_ProductFeature,
    public readonly FK_InventoryDetail
  ) {}
}

export class TagsByFather {
  static readonly type = "[Admin] Query TagsByFather]";
  constructor(public readonly father: any, public readonly isAdmin: boolean) {}
}

export class SearchTagByCategory {
  static readonly type = "[Admin] Query SearchTagByCategory]";
  constructor(public readonly value, public readonly categoryId) {}
}

export class FindTags {
  static readonly type = "[Admin] Query FindTags]";
  constructor(public readonly criteria: string) {}
}

export class CategoriesTagsClient {
  static readonly type = "[Admin] Query CategoriesTagsClient]";
  constructor(public readonly id: string) {}
}

export class SubcategoriesTags {
  static readonly type = "[Admin] Query SubcategoriesTags]";
  constructor(public readonly id: string) {}
}

export class TagCategories {
  static readonly type = "[Admin] Query TagCategories]";
}

export class SonTags {
  static readonly type = "[Admin] Query SonTags]";
  constructor(public readonly tag: Tag) {}
}

export class TagsByCategory {
  static readonly type = "[Admin] Query TagsByCategory]";
  constructor(public readonly id: string) {}
}

export class UpdateTag {
  static readonly type = "[Admin] Query UpdateTag]";
  constructor(public readonly tagUpdate: any) {}
}

export class GetPromotionalCodes {
  static readonly type = "[Admin] Query GetPromotionalCodes]";
}

export class FindTagsToAssign {
  static readonly type = "[Admin] Query FindTagsToAssign]";
  constructor(
    public readonly criteria: string,
    public readonly fatherId: number
  ) {}
}

export class AddSonTag {
  static readonly type = "[Admin] Mutation AddSonTag]";
  constructor(public readonly tag: Tag, public readonly FK_FatherTag: number) {}
}

export class AddTag {
  static readonly type = "[Admin] Query AddTag]";
  constructor(public readonly tag: any) {}
}

export class RemoveSonTag {
  static readonly type = "[Admin] Query RemoveSonTag]";
  constructor(public readonly tag: any) {}
}

export class UpdatePromotionalCode {
  static readonly type = "[Admin] Mutation UpdatePromotionalCode]";
  constructor(public readonly promotionalCode) {}
}

export class UpdatePromotionalCodeState {
  static readonly type = "[Admin] Mutation UpdatePromotionalCodeState]";
  constructor(public readonly id, public readonly FK_PromotionalCodeState) {}
}

export class GenerateRandomPromotionalCodeName {
  static readonly type = "[Admin] Query GenerateRandomPromotionalCodeName]";
}

export class CreatePromotionalCode {
  static readonly type = "[Admin] Mutation CreatePromotionalCode]";
  constructor(public readonly promotionalCode) {}
}

export class CreateProductKeyFeature {
  static readonly type = "[Admin] Mutation CreateProductKeyFeature]";
  constructor(public readonly productKeyFeature) {}
}

export class CreateProductDiscount {
  static readonly type = "[Admin] CreateProductDiscount]";
  constructor(public readonly discount: any) {}
}

export class DiscountsByPlace {
  static readonly type = "[Admin] DiscountsByPlace]";
  constructor(public readonly state: boolean) {}
}

export class SetProductDiscount {
  static readonly type = "[Admin] SetProductDiscount]";
  constructor(
    public readonly discount: ProductDiscount,
    public readonly id: string,
    public readonly FK_Detail: string,
    public readonly FK_Feature: string
  ) {}
}

export class RemoveProductDiscount {
  static readonly type = "[Admin] RemoveProductDiscount]";
  constructor(
    public readonly discount: ProductDiscount,
    public readonly id: string,
    public readonly FK_Detail: string,
    public readonly FK_Feature: string
  ) {}
}

export class BillsByPlaceAndStateAndIds {
  static readonly type = "[Admin] BillsByPlaceAndStateAndIds]";
  constructor(
    public readonly place: any,
    public readonly statesFilter: number[],
    public readonly billDetailState: number,
    public readonly details: string[]
  ) {}
}

export class BillsPendingState {
  static readonly type = "[Admin] BillsPendingState]";
  constructor(
    public readonly place: any,
    public readonly stateFilter: number,
    public readonly idsBills: string[]
  ) {}
}

export class currentCartsBills {
  static readonly type = "[Admin] CurrentCartsBills]";
  constructor(public readonly place: any) {}
}

export class getUserByPlace {
  static readonly type = "[Admin] getUserByPlace]";
  constructor(public readonly place: any) {}
}

export class ProductsAndCategory {
  static readonly type = "[Admin] ProductsAndCategory]";
  constructor(public readonly place: any) {}
}

export class ServerDate {
  static readonly type = "[Admin] ServerDate]";
}

export class SubscribeUsers {
  static readonly type = "[Admin] SubscribeUsers]";
}

export class RemoveProductFeatureTag {
  static readonly type = "[Admin] RemoveProductFeatureTag]";
  constructor(
    public readonly feature: ProductFeature,
    public readonly tag: Tag
  ) {}
}

export class CreateProductFeatureTag {
  static readonly type = "[Admin] CreateProductFeatureTag]";
  constructor(
    public readonly features: ProductFeature[],
    public readonly tag: any
  ) {}
}

export class Activities {
  static readonly type = "[Admin] Activities]";
}

export class SetPlaceDelivery {
  static readonly type = "[Admin] Mutation SetPlaceDelivery]";
  constructor(public readonly placeDelivery: any) {}
}

export class UsersByCriteria {
  static readonly type = "[Admin] Query UsersByCriteria]";
  constructor(public readonly criteria: any, public readonly updated?: any) {}
}

export class SelectUserBill {
  static readonly type = "[Admin] Query SelectUserBill]";
  constructor(public readonly User: any) {}
}

export class BillsByPlace {
  static readonly type = "[Admin] BillsByPlace]";
}

export class CreateBillCashier {
  static readonly type = "[Admin] CreateBillCashier]";
  constructor(
    public readonly feature: ProductFeature,
    public readonly newBill?: boolean
  ) {}
}

export class CreateBillOnly {
  static readonly type = "[Admin] CreateBillOnly]";
  constructor(
    public readonly feature: ProductFeature,
    public readonly newBill?: boolean
  ) {}
}

export class BillByID {
  static readonly type = "[Admin] BillByID]";
  constructor(public readonly id: string) {}
}
export class GetBillsForDelivery {
  static readonly type = "[Admin] GetBillsForDelivery]";
  constructor() {}
}

export class AddBillCashier {
  static readonly type = "[Admin] AddBillCashier]";
  constructor(public readonly feature: ProductFeature) {}
}

export class ReduceBillCashier {
  static readonly type = "[Admin] ReduceBillCashier]";
  constructor(public readonly detail: ProductFeature) {}
}

export class RemoveBillCashier {
  static readonly type = "[Admin] RemoveBillCashier]";
  constructor(public readonly detail: any) {}
}

export class UpdateQuantityBillDetailCashier {
  static readonly type = "[Admin] UpdateQuantityBillDetailCashier]";
  constructor(
    public readonly id: string,
    public readonly Quantity_BillDetail: Number,
    public readonly SubTotal_BillDetail: Number,
    public readonly Total_BillDetail: Number
  ) {}
}

export class PayBillByCashier {
  static readonly type = "[Admin] PayBillByCashier]";
  constructor(public readonly data) {}
}

export class QueryCabys {
  static readonly type = "[Admin] QueryCabys]";
  constructor(public readonly query) {}
}

export class PlaceData {
  static readonly type = "[Admin] PlaceData]";
  constructor(public readonly route?: any) {}
}

export class FeaturesByCellar {
  static readonly type = "[Admin] FeaturesByCellar]";
  constructor(
    public readonly FK_Cellar: any,
    public readonly newQuery?: boolean
  ) {}
}

export class FeaturesByInventory {
  static readonly type = "[Admin] FeaturesByInventory]";
  constructor(
    public readonly FK_Inventory: any,
    public readonly newQuery?: boolean
  ) {}
}

export class FeaturesByInventoryDetail {
  static readonly type = "[Admin] FeaturesByInventoryDetail]";
  constructor(
    public readonly FK_Inventory_Detail: any,
    public readonly newQuery?: boolean
  ) {}
}

export class QueryFeatures {
  static readonly type = "[Admin] QueryFeatures]";
  constructor(
    public readonly Criteria: any,
    public readonly newQuery?: boolean
  ) {}
}

export class RandomByPlace {
  static readonly type = "[Admin] RandomByPlace]";
  constructor(public readonly newQuery?: boolean) {}
}

export class TagsByInventory {
  static readonly type = "[Admin] TagsByInventory]";
  constructor(public readonly id: string) {}
}

export class FeatureById {
  static readonly type = "[Admin] FeatureById]";
  constructor(public readonly id: string) {}
}

export class CleanCurrentFeature {
  static readonly type = "[Admin] CleanCurrentFeature]";
}

export class DevicesByUser {
  static readonly type = "[Admin] DevicesByUser]";
  constructor(public readonly id: string) {}
}

export class SetDiscountState {
  static readonly type = "[Admin] SetDiscountState]";
  constructor(
    public readonly id: string,
    public readonly State: boolean,
    public readonly remove: boolean
  ) {}
}
export class UpdateFeaturesQuantity {
  static readonly type = "[Admin] UpdateFeaturesQuantity]";
  constructor(
    public readonly newQuantity: any,
    public readonly features: string,
    public readonly FK_InventoryDetail: string
  ) {}
}

export class UpdateDeliveryMoment {
  static readonly type = "[Admin] Mutation UpdateDeliveryMoment]";
  constructor(
    public readonly id: string,
    public readonly DeliveryMoment: Date
  ) {}
}

export class LocationsByPlace {
  static readonly type = "[Reports] LocationsByPlace]";
}

export class createRefundsByBill {
  static readonly type = "[Admin] createRefundsByBill]";
  constructor(public readonly refunds) {}
}
export class updateRefundState {
  static readonly type = "[Admin] updateRefundState]";
  constructor(public readonly refund) {}
}

export class updateGalleryFileState {
  static readonly type = "[Admin] updateGalleryFileState]";
  constructor(public readonly id) {}
}

export class UpdateInventoryAll {
  static readonly type = "[Admin] UpdateInventoryAll]";
  constructor(public readonly inventory) {}
}
export class AllPersonTypes {
  static readonly type = "[Admin] AllPersonTypes]";
}

export class LoadTags {
  static readonly type = "[Tag] Load Tags";
}

export class SaveTag {
  static readonly type = "[Tag] Save Tag";
  constructor(public payload: any) {}
}

export class EditFeatureTag {
  static readonly type = "[Reports] EditFeatureTag";
  constructor(public feature: any, public tagId: string) {}
}

export class ResetBillDetail {
  static readonly type = "[Admin] Reset Bill Detail";
}
export class RemoveTag {
  static readonly type = "[Tags] Remove Tag";
  constructor(public id: number) {}
}

export class UpdateFeatureState {
  static readonly type = "[Admin] Update Feature State";
  constructor(public featureId: number, public action: number) {}
}
